import en from './en';
import pl from './pl';

const translations = {
  en,
  pl,
};

export default translations;
